import { Coord } from "../../../../../../../src/types/Interface";


export function createLinesFromShapeCoord(shapeCoords: Coord[]): Coord[][] {
  return [...shapeCoords].map((coord: Coord, cI) => {
    const nextCoord = shapeCoords[cI !== shapeCoords.length - 1 ? cI + 1 : 0];
    return [coord, nextCoord];
  })
}